/**
 * Format seconds to mm:ss format
 */
export const formatTimeToMinutes = (time: number): string => {
  const minutes = Math.floor(time / 60);
  const seconds = Math.floor(time % 60);
  return `${minutes}:${seconds.toString().padStart(2, '0')}`;
};

/**
 * Format timestamp to display format
 * Handles both Date objects and numeric timestamps
 */
export const formatTimestamp = (timestamp: Date | number): string => {
  if (timestamp instanceof Date) {
    return timestamp.toLocaleTimeString();
  }
  // If it's a number, format as mm:ss
  return formatTimeToMinutes(timestamp);
};
